import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wordclipPipe'
})
export class WordclipPipePipe implements PipeTransform {

  transform(value: string | undefined, maxWords: number = 30): string {
    if (!value) {
      return '';
    }

   
    const words = value.split(/\s+/).filter(word => word.length > 0);
    
    if (words.length <= maxWords) {
      return value; // Return original value if it's short enough
    }
    
    return words.slice(0, maxWords).join(' ') + '....';
  }

}
